import {React} from 'react'
import  './footer.css'

function Footer() {
    return (
      <div className="footerbody">
        {/* <h4>© 2021 Developed by Rajnarayana Dasari Inspired from Huxly Gerard Singh A</h4> */}
      </div>
    );
}

export default Footer